import { memo } from 'react';

import SideMenu from './components/SideMenu/SideMenu';
import DashboardMenu from './components/DashboardMenu/DashboardMenu';

interface AccordionSideMenuProps {
  isMobile?: boolean;
  isDashboard?: boolean;
  pageType?: string;
}

const AccordionSideMenu: React.FC<AccordionSideMenuProps> = ({
  isMobile,
  isDashboard,
  pageType,
}) => {
  if (isDashboard) {
    return <DashboardMenu />;
  }

  return <SideMenu isMobile={isMobile} pageType={pageType} />;
};

export default memo(AccordionSideMenu);
